<template>
  <div class="inner-content">
    <el-cascader
      ref="cascaders"
      placeholder="请输入或选择行政区"
      :props="props"
      v-model="place"
      :options="regionList"
      @change="handleCasChange"
      class="custome-popper-class"
      filterable
    ></el-cascader>
    <dt class="cascader-dt">中国城市列表</dt>
    <div class="region-div">
      <dl
        v-for="(item, index) in regionList"
        :key="index"
        :class="[
          'search-list',
          {
            'is-active': regionActiveId === item.regionId
          }
        ]"
      >
<!--        <dt @click="handleRegionClick(item,1)" class="parent-region region-disabled">{{ item.regionName }}</dt>-->
        <dt class="parent-region region-disabled">{{ item.regionName }}</dt>
        <dd>
          <ul
            v-for="(city, index) in item.children"
            :key="index"
            @click="$store.state.user.limitRegionType < 3 ? handleRegionClick(city,2): () => {}"
          >
            <li :class="[{ 'is-active': regionActiveId === city.regionId}, $store.state.user.limitRegionType < 3 ? 'parent-region' : 'parent-region region-disabled']">
              {{ city.regionName }}
            </li>
            <li
              v-for="(con, index) in city.children"
              :key="index"
              @click.stop="handleRegionClick(con,3)"
              :class="[
                {
                  'is-active': regionActiveId === con.regionId
                }
              ]"
            >
              {{ con.regionName }}
            </li>
          </ul>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
export default {
  props: ['regionList'],
  data() {
    return {
      props: {
        label: 'regionName',
        value: 'com',
        children: 'children',
        checkStrictly: this.$store.state.user.limitRegionType < 3
      },
      place: [],
      regionActiveId: ''
    };
  },
  mounted() {
    this.$nextTick(function() {
      // this.$refs.cascaders.toggleDropDownVisible();
    });
  },
  methods: {
    handleCasChange(val) {
      // this.$refs.cascaders.toggleDropDownVisible();
      var region = val[val.length - 1].split(',');
      var regionActiveId = region[region.length - 2];
      this.handleRegionClick({ regionId: regionActiveId,regionName:region[1] },val.length);
    },
    handleRegionClick(val,level) {
      let limitRegionType = this.$store.state.user.limitRegionType;
      if(!limitRegionType) {
        limitRegionType = 3
      }
      if (level < limitRegionType) {
         this.$refs.cascaders.toggleDropDownVisible();
         return;
      }
      if (this.regionActiveId === val.regionId) {
        this.regionActiveId = '';
        this.$emit('clearPolygonItem');
        return;
      } else {
        this.regionActiveId = val.regionId;
      }
      // console.log(val);
      this.$bus.$emit('create-polygon-item', {
        name: val.regionName,
        code: val.regionId
      });
    }
  }
};
</script>
<style lang="less" scoped>
.inner-content {
  maxHeight: "300px";
  position: absolute;
  top: 180px;
  right: 50px;
  z-index: 1500;
  background: rgba(255, 255, 255, 0.9);
  color: @black-color;
  padding: 20px;
  width: 314px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);

  /deep/ .el-input__inner {
    background: rgba(255, 255, 255, 0.6);
  }
}
.cascader-dt {
  /* font-size: 16px; */
  margin-top: 10px;
  margin-bottom: 10px;
}
.region-div {
  max-height: 164px;
  overflow: auto;
  top: 10px;
}
.search-list {
  display: flex;
  font-size: 14px;
  padding: 5px 0px 0;
  border-top: 1px solid rgba(217, 224, 232, 0.5);
  color: @black-color;
  .parent-region {
    color: #e6a23c;
    font-weight: bold;
  }
  .region-disabled {
    cursor: default;
  }
  &.is-active {
    cursor: pointer;
    border-radius: 4px;
    color: #537dfc;
    dt {
      color: #537dfc;
    }
  }
  .tit {
    font-size: 14px;
  color: @black-color;

  }
  .li-input {
    padding: 0;
    display: flex;
  }
  .li-input:hover {

  }
  dt {
    line-height: 14px;
    /*width: 55px;*/
    word-break: break-all;
    padding: 10px 5px;
    /*margin-right: 60px;*/
    font-size: 14px;
    color: @black-color;
    /*position: absolute;*/
    white-space: nowrap;
    &:hover {
      //cursor: pointer;
      /*border: 1px solid #537dfc;*/
      border-radius: 4px;
      color: #537dfc;
    }
  }
  dd {
    color: @black-color;

    /*margin-left: 55px;*/
    ul {
      cursor: pointer;
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      align-items: center;
      font-size: 14px;
      position: relative;
      &.is-active {
        cursor: pointer;
        border-radius: 4px;
        color: #537dfc;
      }
      li {
        cursor: pointer;
        padding: 10px 4px;
        /*margin-right: 14px;*/
        line-height: 12px;
        font-size: 14px;
        /*margin-bottom: 3px;*/
        transition: all 0.2s;
        &.is-active {
          cursor: pointer;
          border-radius: 4px;
          color: #537dfc;
        }
      }
      li:hover {
        border-radius: 4px;
        color: #537dfc;
      }
    }
  }
  .search-input {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 8px;
      height: 2px;
      background: #2b313d;

      margin: 0 6px;
    }
    input {
      width: 40px;
      height: 30px;
      padding: 4px;
      border: 1px solid #c0c5cc;
      border-radius: 2px;
      background: #fff;
    }
  }
}
/deep/.custome-popper-class {
  width: 100%;

  .el-input__inner {
    border-radius: 18px !important;
  }
}
</style>
